import { Component, OnInit } from '@angular/core';
import { ScApiService } from '@sc-ui';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss']
})
export class ImprintComponent implements OnInit {

  constructor(private api : ScApiService, public loc : LocalizationService) { }

  ngOnInit() {
  }

}

